import React from 'react';
import { RouteConfig } from '../../../routes';

import RouteWithAuthentication from '../../RouteWithAuthentication';
import RouteWithSubRoute from '../../RouteWithSubRoute';

import { TRenderIfAuthenticating, TRenderIfUnauthorized } from '../../types';

const DefaultRoutes = ({
  route,
  renderIfAuthenticating,
  renderIfUnauthorized,
  ...props
}: {
  route: RouteConfig;
  computedMatch?: {
    url: string;
  };
  renderIfAuthenticating: TRenderIfAuthenticating;
  renderIfUnauthorized: TRenderIfUnauthorized;
}) => {
  if (route.permissions && route.permissions.length > 0) {
    return (
      <RouteWithAuthentication
        renderIfAuthenticating={renderIfAuthenticating}
        renderIfUnauthorized={renderIfUnauthorized}
        {...route}
        {...props}
      />
    );
  }

  return <RouteWithSubRoute {...route} {...props} />;
};

export default DefaultRoutes;
